import type { ComponentProps } from "react"
import BaseTabs from "@/v2-ui/tabs"
import { useTabsState } from "./tabs.context"

export type TabsContentProps = ComponentProps<typeof BaseTabs.Content>

function TabsContent(props: TabsContentProps) {
  const state = useTabsState()

  if (state?.isLoading || state?.error || state?.isEmpty) {
    return null
  }

  const { className, ...baseTabsContentProps } = props
  return <BaseTabs.Content className={className} {...baseTabsContentProps} />
}

export default TabsContent
